import { GET_ISSUE_TYPES, GET_ISSUE_TYPES_SUCCESS, GET_ISSUE_TYPES_ERROR, GET_ISSUE_TYPES_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetIssueTypes = (state = initialState, action) => {
  switch (action.type) {
    case GET_ISSUE_TYPES:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_ISSUE_TYPES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_ISSUE_TYPES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_ISSUE_TYPES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetIssueTypes;
